import { PageHeader } from '@core/components/PageHeader';
import { SearchBar } from '@core/components/SearchBar';
import { Button, makeStyles } from '@material-ui/core';
import React, { useContext } from 'react';
import { FaShoppingBag } from 'react-icons/fa';
import { CompraContext } from '../../CompraContext';
import { compraModais } from '../modal/compraModais';

const searchHeaderCompraStyles = makeStyles({
  searchBarContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    maxWidth: '512px',
  },
  link: {
    color: '#53c4e6',
    fontWeight: '600',
    textTransform: 'none',
  },
});

const CompraSearchHeader = () => {
  const [search, setSearch] = useContext(CompraContext).search;
  const [, setModal] = useContext(CompraContext).modal;

  const handleOpenBuscaAvancada = () => {
    setModal(compraModais.buscaAvancada);
  };

  const styles = searchHeaderCompraStyles();

  return (
    <PageHeader title="Compras" icon={<FaShoppingBag />}>
      <div className={styles.searchBarContainer}>
        <div className="flex items-center w-full max-w-512 stepBarraPesquisa">
          <SearchBar searchText={search} onChange={setSearch} />
        </div>
        <div className="stepBuscaAvancada">
          <Button className={styles.link} onClick={handleOpenBuscaAvancada}>
            Busca avançada
          </Button>
        </div>
      </div>
    </PageHeader>
  );
};

export default CompraSearchHeader;
